import React from 'react';
import g2Icon from './g2-icon.svg';
import css from './Badges.module.css';
import classNames from 'classnames';

export const LeaderBadge = ({
  className,
  whiteStyle,
}: {
  className?: string;
  whiteStyle?: boolean;
}) => {
  return (
    <div className={classNames(css.badgeContainer, className)}>
      <div className={classNames(css.badge, { [css.whiteBadge]: whiteStyle })}>
        <div className={css.leaderPennant}>
          <img src={g2Icon} className={css.g2Icon} />
        </div>
        <div className={css.badgeRow1}>Leader</div>
        <div className={css.badgeRow2}>Winter</div>
        <div className={css.badgeRow3}>2022</div>
      </div>
      <div
        className={classNames(css.badgeTriangle, {
          [css.whiteBadgeTriangle]: whiteStyle,
        })}
      />
    </div>
  );
};
